import { render, staticRenderFns } from "./MainRestaurants.vue?vue&type=template&id=ddbd3332&"
import script from "./MainRestaurants.vue?vue&type=script&lang=js&"
export * from "./MainRestaurants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports